<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="ADD_ACTION">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages"
      :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked"
      @update-requested="updateItemsRequested" :sorter="{ external: true }" :sorterValue="sorterValue"
      @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase, htmlToText } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar },
  data() {
    return {
      searchText: '',
      caption: i18n.t('keyValues'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'key', label: i18n.t('key'), _classes: 'font-weight-bold', sorter: true },
        { key: 'readableValue', label: i18n.t('value'), sorter: false },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false
    }
  },
  computed: {
    ...mapState('keyValues', ['getKeyValuesOutput']),
    ...mapState('keyValues', ['deleteKeyValueByIdOutput']),
    keyValueInfo: function () {
      return this.getKeyValuesOutput ? this.getKeyValuesOutput : null;
    },
    items: function () {
      var result = this.keyValueInfo && this.keyValueInfo.data ? this.keyValueInfo.data : [];

      if (result.length) {
        result.forEach(item => {
          item.readableValue = htmlToText(item.value);
        });
      }

      return result;
    },
    pages: function () {
      return this.keyValueInfo ? this.keyValueInfo.totalPages : 1;
    }
  },
  mounted: function () {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('keyValues', ['getKeyValues']),
    ...mapActions('keyValues', ['deleteKeyValueById']),
    rowClicked(item, index) {
      this.$router.push({ name: "KeyValueEdit", query: { id: item.id }, params: { name: item.name } });
    },
    actionClicked(item, action) {
      switch (action.key) {
        case 'view':
          {
            this.$router.push({ name: "KeyValueEdit", query: { id: item.id }, params: { name: item.name } });
            break;
          }
        case 'remove':
          {
            if (confirm(this.$i18n.tc('confirmRemove', item.key, { name: item.key }))) {
              this.deleteKeyValueById(item.id);
            }
            break;
          }
        default:
          {
            throw "The provided action is not supported!";
          }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage) {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      // List specific parameters
      if (this.$route.params.type) {
        input.type = this.$route.params.type;
      }

      this.getKeyValues(input);
    },
    ADD_ACTION() {
      router.push({ name: 'KeyValueAdd', params: { type: this.$route.params.type } });
    },
    searchClicked(searchText) {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value) {
      this.sorterValue = value;
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function (val) {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteKeyValueByIdOutput: function (val) {
      this.loading = true;

      if (val) {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getKeyValuesOutput: function (val) {
      if (val != null) {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th {
  border-top: none !important;
}

tr {
  cursor: pointer;
}

.status-button {
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 